import React, { useState } from 'react';
import { useUploadSpoucalConsentForm } from '../api/uploadSpoucalConsentForm';
import { Button, FullScreenSpinner, Spinner } from 'components/Elements';
import { DocumentUploadField, Form } from 'components/Form';
import { useNavigate } from 'react-router-dom';
import { AssignedTo } from './AssignedTo';
import { UPLOADS_URL } from 'config';
import { Check } from 'react-feather';
import { useDueDeligenceAsset } from '../api/getDueDeligenceAsset';

export const UploadSpoucalConsentForm = () => {
  const [spoucal_consent_form, setSpoucalConsentForm] = useState(null);

  const uploadSpoucalConsentForm = useUploadSpoucalConsentForm();

  const { id } = useParams();

  const assetQuery = useDueDeligenceAsset({ id });

  const navigate = useNavigate();

  if (assetQuery.isLoading) {
    return (
      <div className="w-full h-48 flex justify-center items-center">
        <Spinner size="lg" />
      </div>
    );
  }

  if (uploadSpoucalConsentForm.isLoading) return <FullScreenSpinner />;

  return (
    <div>
      {/* Spoucal Consent Form */}
      {assetQuery.data?.spoucal_consent_form?.document_required &&
        !assetQuery.data?.spoucal_consent_form?.location && (
          <>
            <Form
              id="upload-signed-transfer-forms"
              onSubmit={async () => {
                const bodyFormData = new FormData();
                bodyFormData.append('spoucal_consent_form', spoucal_consent_form);
                await uploadSpoucalConsentForm.mutateAsync({
                  data: bodyFormData,
                  id: assetQuery.data._id,
                });
                navigate(`/app/due-deligences/${id}/process/success`);
              }}
            >
              {({ register, formState }) => (
                <>
                  <div className="bg-white rounded-2xl shadow-md p-12 mb-4">
                    <div className="text-lg mb-2">Spoucal Consent Form</div>
                    <div className="text-sm mb-3">
                      Lorem ipsum dolor sit amet consectetur. Diam sit rutrum enim dui lectus
                      pharetra consectetur donec gravida. Faucibus quisque dignissim faucibus
                      commodo odio tellus. Proin euismod non eget.
                    </div>
                    <div className="flex flex-row items-center justify-between">
                      <div className="">
                        <DocumentUploadField
                          label="Upload Forms"
                          error={formState.errors['spoucal_consent_form']}
                          onChange={(e) => {
                            setSpoucalConsentForm(e.target.files[0]);
                          }}
                        />
                      </div>
                      <div className="">
                        <div className="">Assigned to</div>
                        <AssignedTo id={assetQuery.data?.spoucal_consent_form?.assigned_to} />
                      </div>
                    </div>
                  </div>
                  <div className="flex flex-row justify-end">
                    <Button isLoading={uploadSpoucalConsentForm.isLoading} type="submit">
                      Submit
                    </Button>
                  </div>
                </>
              )}
            </Form>
          </>
        )}

      {assetQuery.data?.spoucal_consent_form?.location && (
        <div className="bg-white rounded-2xl shadow-md p-8 grid grid-cols-1 md:grid-cols-3 mb-4">
          <div className="">
            <div className="">Spoucal Consent Form</div>
            <a
              href={`${UPLOADS_URL}/documents/due_deligence/${assetQuery.data?.spoucal_consent_form?.location}`}
              target="_blank"
              rel="noreferrer"
              className="text-primary-100"
            >
              {assetQuery.data?.spoucal_consent_form?.location}
            </a>
          </div>
          <div className="">
            <AssignedTo id={assetQuery.data?.spoucal_consent_form?.assigned_to} />
          </div>
          <div className="flex justify-end">
            <div className="rounded-full bg-green-400 p-3 h-12 w-12 flex items-center justify-center">
              <Check size={20} className="text-white" />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
